<template>
  <!-- 资质列表 -->
  <div>
    <div class="add_button">
      <el-button type="primary-font-mini" @click="addProfession">增加</el-button>
    </div>
    <div class="fourthStep">
      <div class="table_title">分包专业</div>
      <el-table
        ref="checkedTable"
        border
        :data="checkedTableData"
        class="ccui-form-child-table"
        max-height="600"
      >
        <el-table-column
          type="index"
          label="序号"
          width="120">
        </el-table-column>
        <el-table-column prop="subjectName" min-width="300" label="分包专业名称">
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="请选择分包专业"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <div class="screen-search">
        <el-search
          :formProp="formData"
          @search="onSubmitSingle"
          :isShowSearch="true"
          class="ccui-highsearch"
          :selectClear="true"
          :isShow="false"
          searchBtn="搜索"
        >
        <template slot="search">
          <el-input
            v-model="formData.subjectName"
            searchLabel="分包专业名称"
            placeholder="请输入分包专业名称"
            autocomplete="off"
            maxlength="50"
            clearable
            @keyup.enter.native="onSubmitSingle"
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          ></el-input>
        </template>
        </el-search>
      </div>
      <div class="dialog_content">
        <el-table
          v-if="dialogVisible"
          ref="multipleTable"
          :data="allTableData"
          border
          :row-key="(row)=>{ return row.subjectId}"
          class="ccui-form-child-table"
          max-height="99999"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60">
          </el-table-column>
          <el-table-column
            label="分包专业名称"
            prop="subjectName"
            min-width="120">
          </el-table-column>
        </el-table>
      </div>
      <div class="ccui-table-footer">
        <div id="ccui-paging">
          <el-pagination
            :total="page.total"
            :current-page.sync="page.pageNo"
            :page-size="page.pageSize"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            :page-sizes="[10, 20, 50, 100, 200]"
            layout=" prev, sizes, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { selectSubconSubjectAndProfessionList } from "@/api/subcontractor-register";
export default {
  props: {
    checkedTableData: {
      type: Array,
      default: []
    },
    professionId: {
      type: String,
      default: ""
    },
  },
  components: {
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
  },
  data() {
    return {
      checkOut:false,
      dialogVisible: false,
      allTableData: [],
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 10,
      },
      checkedData: [],
      formData: {}
    };
  },
  mounted() {
    console.log(this.checkedTableData)
    this.getSubconSubjectAndProfessionList();
  },
  methods: {
    // 增加按钮
    addProfession() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSelectionChange(val) {
      this.checkedData = val;
    },
    confirm(){
      this.checkedTableData = this.checkedData;
      this.$emit("setProfession", this.checkedTableData, this.professionId);
      this.dialogVisible = false;
    },
    getSubconSubjectAndProfessionList() {
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      params = Object.assign({}, params, this.formData)
      selectSubconSubjectAndProfessionList(params).then( res => {
        this.allTableData = res.data.data.rows;
        this.page.total = res.data.data.recordsTotal;
        this.page.pageNo = res.data.data.pageNo;
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val;
      this.getSubconSubjectAndProfessionList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getSubconSubjectAndProfessionList();
    },
    onSubmitSingle(obj) {
      this.page.pageNo = 1
      this.getSubconSubjectAndProfessionList();
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {

}


.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
.add_button {
  display: block;
  width: 100%;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
  /deep/ .el-button {
    float: right;
  }
}
/deep/ .el-table__body td{
  padding: 12px 0 !important;
}
.dialog_content {
  max-height: 600px;
  overflow: auto;
    /deep/ .el-table__body td{
      padding: 5px 0 !important;
    }
    /deep/ .el-table__header-wrapper th{
      padding: 5px 0 !important;
    }
}
/deep/ .el-dialog__body {
  max-height: unset !important;
}
#ccui-paging {
  margin-top: 10px;
}
/deep/ .el-searchs-right .el-input {
  margin-top: 5px;
}
</style>
